var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vg-work-order-track"},[_c('van-steps',{attrs:{"direction":"vertical","active":0}},_vm._l((_vm.value),function(step){return _c('van-step',{key:step,staticClass:"vg-work-order-track-step-wrapper"},[_c('div',{staticClass:"vg-work-order-track-step-content"},[_vm._v(_vm._s(_vm._f("stripHtml")(step)))])])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }